var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidCultureResponsiveLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 850,
    height: 170,
    viewBox: "0 0 838 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 83H804V258H1V83Z",
    fill: "#F3DABE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 85.7487L400.007 53.8138C453.507 26.2255 502.894 65.5644 546.5 65.5644C668.8 47.2744 666.5 64.0316 741 71.1841C787 77.8257 806 56.1169 837.5 85.7487L830 85.7487L822.5 85.7487H719H537.993C537.993 85.7487 438.257 85.7487 413.5 85.7487H240Z",
    fill: "#E5B279"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.389 59C29.5606 59 8.29773 74.2182 0 83.0545V86H432C418.516 71.2727 387.4 59 347.467 59C311.592 59 284.888 63.9092 274.343 69.6364C269.33 68.1637 167.51 59 108.389 59Z",
    fill: "#EDC79E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.926 71.1741C282.294 71.1741 288.793 53.1294 253.066 54.0328C201.041 55.3485 176.864 75.7041 167.236 87.362C164.603 90.578 162 95 162 95H313.596C314.891 95 365 95 365 95C365 91.2326 349.233 71.1741 324.926 71.1741Z",
    fill: "#BFC8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 85.9974C340 73.9974 324.066 88.185 310.5 88.4975C275.496 89.3629 268.001 92.8047 261.523 100.473C259.751 102.589 258 105.497 258 105.497H360C360.872 105.497 380 105.497 380 105.497C380 103.019 367.257 88.5343 362.5 85.9974Z",
    fill: "#586753"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.046 24.9702C237.768 11.6695 234.692 0.688566 230.175 0.443599C225.658 0.198632 221.412 10.7824 220.69 24.0831C219.969 37.3839 223.045 48.3648 227.562 48.6098C232.078 48.8548 236.325 38.271 237.046 24.9702Z",
    fill: "#586753",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.333 16.9916L226.355 73.8655",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.461 26.2223L228.886 28.6045",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.589 33.6666L232.906 31.2844",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.015 36.0488L228.439 38.431",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.184 21.0115L233.502 18.4805",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.611 23.2446L229.035 25.7757",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.553 53.583C217.25 53.4118 219.83 44.2841 219.317 33.1957C218.804 22.1073 215.391 13.2572 211.694 13.4284C207.997 13.5995 205.416 22.7272 205.93 33.8156C206.443 44.904 209.856 53.7542 213.553 53.583Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.356 27.2646L214.59 74.61",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.974 35.1556L212.952 36.9423",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.101 41.1109L216.525 38.7288",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.272 43.3442L213.398 45.1309",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.654 30.5402L215.93 28.1581",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.825 32.7732L212.803 34.5598",
    stroke: "#2F462F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M361.842 55.3437C361.962 47.4424 357.389 40.972 351.629 40.8918C345.87 40.8115 341.103 47.1518 340.984 55.0532C340.864 62.9545 345.436 69.4249 351.196 69.5051C356.956 69.5854 361.722 63.2451 361.842 55.3437Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6 50.802L351.658 91.2118",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M347.186 56.3132L351.673 57.7418",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M351.527 60.6486L356.914 59.1769",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M347.104 62.0983L351.59 63.5268",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M351.595 53.1549L356.981 51.6831",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M347.171 54.6045L351.658 56.033",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidCultureResponsiveLeft);
export default __webpack_public_path__ + "static/media/mid_culture_responsive-left.d47cf2e8ce71f49b64496c2dcd2ab671.svg";
export { ForwardRef as ReactComponent };